import moment from 'moment';
import {
	getOrderItemByRoomId,
	getOrderById,
	bookingGoToStep,
	updateBookingField,
} from 'actions/booking';

import { withAsyncEnterLoader, withLoader } from 'util/routeHelper';
import { getRoomById } from 'actions/room';

export default store => ({
	path: 'renew',
	indexRoute: {
		getComponent: withLoader(
			(nextState, cb) =>
				require.ensure(
					[],
					require => {
						const component = require('./component').default;
						cb(null, component);
					},
					'BookingRenew',
				),
			store,
			'BookingRenew',
		),
	},
	onEnter: withAsyncEnterLoader(
		async ({ params: { id: orderId } }, replace, updateRatio) => {
			store.dispatch(bookingGoToStep(0));
			await store.dispatch(getOrderById(orderId));
			updateRatio(0.5);

			const { booking } = store.getState();

			const { roomId, dateTo, detail } = booking.data[orderId];

			await Promise.all([
				store.dispatch(getRoomById(roomId)),
				store.dispatch(getOrderItemByRoomId(roomId)),
				store.dispatch(
					updateBookingField('form', 'dateFrom', {
						value: moment(dateTo)
							.add(1, 'days')
							.format('X'),
					}),
				),
				store.dispatch(
					updateBookingField('form', 'orderItem', {
						value: detail.map(item => item.order_item_id),
					}),
				),
			]);
			updateRatio(0.8);
		},
		store,
		'ENTER_BOOKING_RENEW',
	),
});



// WEBPACK FOOTER //
// ./src/routes/User/Booking/Renew/index.js